<template>
  <div class="Product">
    <div id="carouselOne" class="carousel slide" data-ride="carousel">

      <div class="carousel-inner">
        <div class="carousel-item active">
          <img class="d-block carouse-img-one" src="../assets/CopierSelfprinting/banner1.png" alt="自助打印解决方案专家">
          <div class="content-detail">
            <h1 class="left">复印机自助打印软件</h1>
            <p class="right" style="margin-top:50px">让普通复印机秒变自助复印机
            </p>
            <p class="right ">无需电脑 无需盒子 高校投放神器</p>
            <!-- <el-button class="download-btn" type="primary" icon="el-icon-download" @click="goDownloadFn()">立即下载</el-button> -->
          </div>
        </div>

      </div>
    </div>

    <!-- 轮播图下方单行介绍 -->
    <div class="section-wrap" style="background-color: #F1F9FF;">
      <div class="container">
        <div class="row" style="padding: 120px 0; align-items: center;">
          <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7 list-item">
            <h2>复印机自助打印软件</h2>
            <div class="hero-brief">
              <h4 style="color: #0073CA;">24h无人自助</h4>
              <p class="secd" style="margin: 4px 0;">自助打印、自助复印、自助扫描，支持混合支付（微信、支付宝）
              </p>
            </div>
            <div class="hero-brief">
              <h4 style="color: #0073CA;margin-top: 10px;">运营省心：</h4>
              <p class="secd" style="margin: 4px 0;">无需拨打热线，设备自动报障（缺纸、缺墨、器件故障)，平台智能退费机制，可实现人工或自动退费</p>
            </div>
            <div class="hero-brief">
              <h4 style="color: #0073CA;margin-top: 10px">安全可靠</h4>
              <p class="secd" style="margin: 4px 0;">安心使用，拒绝法务风险，内容合规监测；敏感内容、违反国家相关政策的禁止打印</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-5 col-lg5 list-icon">
            <img class="icon" src="../assets/CopierSelfprinting/advert_1.png" alt="复印机功能示意"
              style="width: 130%;height: auto;transform: translateX(-14%);min-width: 444px;">
          </div>
        </div>
      </div>
    </div>

    <div class="section-wrap">
      <div class="container">
        <div class="video-block" style="padding: 100px 0;text-align: center;">
          <div class="video-cover" @click="openVideo(require('../assets/CopierSelfprinting/publicity.mp4'))">
            <img class="video-poster" src="../assets/CopierSelfprinting/publicity.png" alt="宣传视频">
            <!-- <span class="play-btn"></span> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 视频弹窗 -->
    <VideoModal ref="videoModal" />

    <div class="section-wrap" style="background-color: #F1F6FB;">
      <div class="container" style="padding: 100px 0;">
        <div style="text-align:center;">
          <h2 style="margin-bottom: 10px;">高品质原生复印、打印、扫描功能</h2>
          <p class="secd" style="color: #555;">印点点复印机自助打印软件，为用户提供原生的复印、打印、扫描功能</p>
          <p class="secd" style="color: #555;">无论是高精度色彩还原、高分辨率质量输出，高负载生产效率均能得到保障</p>
        </div>
        <div class="row" style="align-items: center;">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 list-item">
            <div class="trigger" :class="{'active': activeIndex === 0}" @click="activeIndex=0" style="margin-bottom: 26px;width: 95%;">
              <h4 @click="activeIndex=0">打印</h4>
              <p class="secd label" style="margin-bottom: 4px;font-weight: 700;">打印界面简洁 流程清晰易懂</p>
              <p class="secd">我们提供打印色彩、单双面、输出尺寸、打印份数、打印预览等常规操作，既满足功能需求，也做到界面简洁清晰，哪怕第一次使用也毫无压力</p>
              <div class="line" style="height:1px;margin:14px 0 0;width: 100%;"></div>
            </div>
            <div class="trigger" :class="{'active': activeIndex === 1}" @click="activeIndex=1" style="margin-bottom: 26px;width: 90%;">
              <h4>复印</h4>
              <p class="secd label" style="margin-bottom: 4px;font-weight: 700;">复印界面简洁 流程清晰易懂</p>
              <p class="secd">不用担心使用困难问题，人性化图标和文字组合，让你第一次使用也可轻松上手</p>
              <div class="line" style="height:1px;margin:14px 0 0;width: 100%;"></div>
            </div>
            <div class="trigger" :class="{'active': activeIndex === 2}" @click="activeIndex=2" style="width: 90%;">
              <h4>扫描</h4>
              <p class="secd label" style="margin-bottom: 4px;font-weight: 700;">拥有高品质电子文件如此简单</p>
              <p class="secd">支持扫描保存为PDF电子文件格式，并可将多页原稿按单个文件或每页一个文件进行保存</p>
              <div class="line" style="height:1px;margin:14px 0 0;width: 100%;"></div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 list-icon" style="text-align:center;">
            <img class="icon" v-if="activeIndex === 0" src="../assets/CopierSelfprinting/advert_2.png" alt="打印功能展示" style="max-width:100%;height:auto;">
            <img class="icon" v-if="activeIndex === 1" src="../assets/CopierSelfprinting/advert_2_2.png" alt="复印扫能展示" style="max-width:100%;height:auto;">
            <img class="icon" v-if="activeIndex === 2" src="../assets/CopierSelfprinting/advert_2_3.png" alt="扫描功能展示" style="max-width:100%;height:auto;">
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div style="padding: 90px 0;text-align: center;">
        <h2 style="margin-bottom: 24px;">资金清算安全</h2>
        <p style="margin: 4px 0;color: #555;">商家可在后台开通微信商户，独立收款，交易资金不经过平台，</p>
        <p style="margin: 4px 0;color: #555;">由腾讯正规支付机构清算到商家银行卡，保障资金的合法合规。</p>
      </div>
    </div>

    <!-- 六宫格优势（放在软件下载上方） -->
    <div class="section-wrap" style="background-color: #F1F9FF;">
      <div class="container" style="padding: 100px 0; text-align: center;">
        <h2 style="margin-bottom: 6px;">复印机自助打印软件</h2>
        <p class="secd" style="margin-bottom: 40px;">优势特点</p>
        <div class="row icons-grid">
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/CopierSelfprinting/icon_1.png" alt="稳定输出">
              <h5>稳定输出</h5>
              <p class="secd">面对多种手机终端、各种打印方式，均能稳定服务，移动打印成功率超过99.99%；</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/CopierSelfprinting/icon_2.png" alt="持续收入">
              <h5>持续收入</h5>
              <p class="secd">投资见效快，7×24小时不停断输出，平均2个月以内回本；</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/CopierSelfprinting/icon_3.png" alt="预收款项">
              <h5>预收款项</h5>
              <p class="secd">支持充值、支付，帮助投放伙伴快速回笼资金；</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/CopierSelfprinting/icon_4.png" alt="运维省心">
              <h5>运维省心</h5>
              <p class="secd">自动化运维监测能力，设备故障自动叫修，打印失败自动退费，运维极度省心；</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/CopierSelfprinting/icon_5.png" alt="自动审计">
              <h5>自动审计</h5>
              <p class="secd">平台提供内容合规自动审计能力，敏感信息自动提示用户禁止打印，杜绝涉密风险；</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div class="icon-item-box">
              <img class="icon-img" src="../assets/CopierSelfprinting/icon_6.png" alt="自动分账">
              <h5>自动分账</h5>
              <p class="secd">平台提供自动分账能力，支持与投方/渠道商/经营商的联合式投放运营；</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="container">
        <div style="padding: 90px 0;text-align: center;">
          <h2 style="margin-bottom: 24px;">软件下载</h2>
          <p style="margin: 4px 0;color: #555;">复印机自助打印软件</p>
          <div class="center_right2" v-if="dataList.length">
            <div v-for="(item,index) of dataList" :key="index" class="item">
              <img v-if="index==0" src="../assets/printing/img4.png" alt="/">
              <img v-else src="../assets/printing/img3.png" alt="/">
              <div class="center_right2_tit">
                <!-- <p>{{item.name||""}}</p> -->
                <p>复印机自助打印软件</p>
                <p v-if="index==0">点击复印机屏幕，进行打印、复印、扫描操作，手机扫码付费后出纸。</p>
                <p v-else>电脑提交文件，弹出收费框，支付后出纸。</p>
              </div>
              <div class="center_right2_dow">
                <button v-if="item.url" class="btn btn-primary" @click="jumpFun(item.url)">下载</button>
                <!-- <p>（ {{item.version}} ）</p> -->
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
    
    <script>

import VideoModal from './comm/VideoModal.vue'

export default {
  components: { VideoModal },
  data() {
    return {
      show: false,
      dataList: [],
      activeIndex: 0,
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.getDataListFun()
  },
  mounted() {
    // setTimeout(() => {
    //   this.show = true;
    //   $("#carouselOne").carousel({
    //     interval: 4000
    //   });
    //   $("#carouselTwo").carousel({
    //     interval: 4000
    //   });
    // }, 200);
  },
  methods: {
    goDownloadFn() {
      this.$router.push("/DownLoad")
    },
    getDataListFun() {//获取数据
      axios.get(`/ProductSystem/Issue/TreeList?id=3`)
        .then((res3) => {
          let hasAnyData = false;
          if (res3 && res3.isSuccess) {
            try {
              const arr3 = JSON.parse(res3.data)
              const second = (arr3 && arr3[1] && arr3[1].data && arr3[1].data[0]) ? arr3[1].data[0] : null
              if (second) {
                this.$set(this.dataList, 0, second)
                hasAnyData = true
              }
            } catch (e) { }
          }
          if (!hasAnyData) {
            this.$message({
              message: "获取数据异常!",
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "网络异常!",
            type: "error"
          });
        })
    },
    jumpFun(url) {
      window.open(url);
    },
    openVideo(src) {
      if (this.$refs.videoModal && this.$refs.videoModal.open) {
        this.$refs.videoModal.open(src)
      }
    },
  },
  filters: {
    timeFun(val) {
      var time = new Date(val);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      return y + "-" + m + "-" + d
    }
  }
};
    </script>
    
    <style lang="less" scoped>
/* Chrome, Safari, Opera */
.content {
  width: 100%;
  position: relative;
  background: no-repeat center center;
  background-size: cover;
  padding-top: 61px;
  height: 540px;
  overflow: hidden;
}

.content-detail {
  position: absolute;
  top: 8rem;
  left: 15vw;

  h1 {
    font-size: 2.8rem;
    line-height: 2rem;
    color: #fff;
  }

  p {
    font-size: 1.75rem;
    color: #fff;
  }
}

.carouse-img-one {
  width: 100%;
}

.active {
  opacity: 1 !important;
}

.content-title {
  text-align: center;
  padding: 60px 0 70px;

  h1 {
    color: #18182a;
    font-weight: normal;
    font-stretch: normal;
    font-size: 40px;
  }
}

.card-kind {
  border: 0px;
  background-color: inherit;

  .version-tit {
    padding-bottom: 50px;
    position: relative;

    &::after {
      content: "";
      width: 64px;
      height: 3px;
      background-color: #00cd95;
      position: absolute;
      border-radius: 99px;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .card-body {
    background-color: #fff;
    padding: 50px 0;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.1, 1.1);
    }

    .version-img {
      width: 120px;
      height: 120px;
      box-shadow: 8px 14px 25px 1px rgba(0, 255, 185, 0.2);
      margin-bottom: 20px;
    }

    .tit-h {
      color: #00cd95;
      font-weight: 500;
    }
  }

  &:nth-child(2) {
    .version-tit::after {
      background-color: #ff725e;
    }

    .tit-h {
      color: #ff725e;
    }

    .version-img {
      box-shadow: 8px 14px 25px 1px rgba(255, 114, 94, 0.2);
    }
  }

  &:nth-child(3) {
    .version-tit::after {
      background-color: #00cbf1;
    }

    .tit-h {
      color: #00cbf1;
    }

    .version-img {
      box-shadow: 8px 14px 25px 1px rgba(0, 203, 241, 0.2);
    }
  }
}

.list-item {
  text-align: left;

  h2 {
    font-size: 40px;
    line-height: 28px;
    color: #18182a;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    line-height: 28px;
    color: #555;
  }
}

.content-detail {
  position: absolute;
  top: 8rem;
  left: 15vw;

  h1 {
    font-size: 2.8rem;
    line-height: 2rem;
    color: #fff;
  }

  p {
    font-size: 1.75rem;
    color: #fff;
  }
}

.center_right2 {
  padding: 44px 0;
  display: flex;
  gap: 40px;
  .item {
    width: 100%;
    min-height: 180px;
    background: #ffffff;
    box-shadow: 0px 1px 44px 2px rgba(38, 38, 38, 0.06);
    border-radius: 8px;
    padding: 20px 36px;
    display: flex;
    align-items: center;
    img {
      width: 65px;
      height: 68px;
      margin-right: 19px;
    }
    .center_right2_tit {
      flex: 1;
      text-align: left;
    }
    .center_right2_tit P:nth-of-type(1) {
      font-size: 20px;
      font-weight: 700;
    }
    .center_right2_tit P:nth-of-type(1) span {
      opacity: 0.6;
      font-size: 16px;
      font-weight: 400;
      margin-left: 17px;
    }
    .center_right2_tit P:nth-of-type(2) {
      font-size: 16px;
      opacity: 0.6;
    }
    .center_right2_dow button {
      width: 140px;
      height: 44px;
      background: rgba(27, 138, 249, 1);
      border-radius: 22px;
      margin-bottom: 13px;
    }
    .center_right2_dow p {
      font-size: 16px;
      color: rgba(24, 24, 42, 1);
      opacity: 0.3;
      width: 140px;
      text-align: center;
    }
  }
}

/* 视频与图片块样式 */
.video-cover {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.video-poster {
  max-width: 100%;
}
.play-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 72px;
  height: 72px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}
.play-btn::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-40%, -50%);
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 18px solid #fff;
}
.full-width-img {
  max-width: 100%;
}
.video-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-content {
  position: relative;
  width: 80%;
  max-width: 900px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}
.video-content video {
  width: 100%;
  height: auto;
  display: block;
}
.video-close {
  position: absolute;
  right: 10px;
  top: 6px;
  color: #fff;
  font-size: 28px;
  line-height: 28px;
  cursor: pointer;
  z-index: 2;
}
/* 六宫格样式 */
.icons-grid .icon-item-box {
  padding: 26px 18px;
  margin-bottom: 26px;
  min-height: 230px;
}
.icons-grid .icon-item-box h5 {
  margin: 20px 0 12px;
  color: #18182a;
}
.icons-grid .icon-item-box p {
  color: #555;
}
.icons-grid .icon-img {
  width: 100px;
  height: 100px;
}

.trigger {
  cursor: pointer;
  .line {
    background: #dfe7f0;
  }
  &.active {
    h4,
    .label {
      color: #1b8af9;
    }
    .line {
      background: #1b8af9;
    }
  }
  &:hover {
    h4,
    .label {
      color: #1b8af9;
    }
    .line {
      background: #1b8af9;
    }
  }
}
</style>
    


// WEBPACK FOOTER //
// src/components/CopierSelfprinting.vue